const UUID_SEGMENT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/**
 * Collapses record identifiers in a pathname so pages aggregate in reporting:
 * `/policy/9f0c…/documents` becomes `/policy/[id]/documents`.
 *
 * Masks any UUID segment rather than matching a list of known routes — every
 * dynamic segment in UPMS is a UUID, and a route list drifts silently the first
 * time someone adds a page.
 */
export const toRouteTemplate = (pathname: string): string => {
  const template = pathname
    .split('/')
    .map((segment) => (UUID_SEGMENT.test(segment) ? '[id]' : segment))
    .join('/')
    .replace(/\/$/, '');

  return template === '' ? '/' : template;
};
